import type {
    CompanyDetails,
    CompanyItems,
    CompanyList,
} from '../domain/company'

interface CompanyBackendResponse {
    totalItems: number
    items: CompanyItemsBackendResponse[]
    page: number
    size: number
}

interface CompanyItemsBackendResponse {
    id: number
    name: string
    warehouse_count: string
    created_at: string
}

interface CompanyDetailsBackendResponse {
    id: number
    name: string
    address: string
    code: string
    phone?: string
    country_id: number
    created_at: string
    updated_at: string
    warehouses: Array<{
        id: number
        name: string
        address: string
        city: string
        code: string
        created_at: string
        company_id: number
    }>
}

interface CompanyCreateBackendResponse {
    name: string
    country_id: number
    address: string
}
interface CompanyCreateRequest {
    commercialName: string
    country: number
    fiscalAddress: string
}

export class CompanyAdapter {
    static fromCreateRequest(
        data: CompanyCreateRequest
    ): CompanyCreateBackendResponse {
        return {
            name: data.commercialName,
            country_id: Number(data.country),
            address: data.fiscalAddress,
        }
    }
    static toDomain(data: CompanyBackendResponse): CompanyList {
        return {
            totalItems: data.totalItems,
            items: data.items.map((item) => ({
                id: item.id,
                name: item.name,
                warehouse_count: item.warehouse_count,
                created_at: item.created_at,
            })),
            page: data.page,
            size: data.size,
        }
    }

    static toCompany(item: CompanyItemsBackendResponse): CompanyItems {
        return {
            id: Number(item.id),
            name: item.name,
            warehouse_count: item.warehouse_count,
            created_at: item.created_at,
        }
    }

    static toDomainList(
        dataList: CompanyItemsBackendResponse[]
    ): CompanyItems[] {
        return dataList.map((item) => this.toCompany(item))
    }
    static toCompanyDetails(
        data: CompanyDetailsBackendResponse
    ): CompanyDetails {
        return {
            id: data.id,
            name: data.name,
            address: data.address,
            code: data.code,
            phone: data.phone,
            country_id: data.country_id,
            created_at: data.created_at,
            updated_at: data.updated_at,
            warehouses: data.warehouses,
        }
    }
}
